export default __webpack_public_path__ + "static/media/add-test-enabled.b5f60b74.svg";